/* Live Free — contact page. The only JS on the page.
   Two jobs: show the order-number field only when the topic needs it, and name
   the topic in the server-rendered sent state. Everything else is <details>. */
(function () {
  'use strict';

  var topic = document.querySelector('[data-lf-topic]');
  var orderField = document.querySelector('[data-lf-order-field]');
  var KEY = 'lf:contact:topic';

  function syncOrderField() {
    if (!topic || !orderField) return;
    var opt = topic.options[topic.selectedIndex];
    orderField.hidden = !(opt && opt.dataset.lfNeedsOrder === 'true');
  }

  if (topic && orderField) {
    syncOrderField();
    topic.addEventListener('change', syncOrderField);
  }

  var form = document.getElementById('lf-contact-form');
  var submit = document.querySelector('[data-lf-submit]');

  if (form && submit) {
    form.addEventListener('submit', function () {
      // Remember the topic so the sent state can name where it was filed.
      try {
        if (topic) sessionStorage.setItem(KEY, topic.value);
      } catch (e) { /* private mode — the sent state just omits the topic */ }

      submit.disabled = true;
      submit.textContent = submit.dataset.lfLabelSending || submit.textContent;
    });
  }

  var sent = document.querySelector('[data-lf-sent]');
  if (sent) {
    var row = sent.querySelector('[data-lf-sent-topic]');
    var name = sent.querySelector('[data-lf-sent-topic-name]');
    var stored = null;
    try { stored = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    if (stored && row && name) {
      name.textContent = stored;
      row.hidden = false;
    }
  }
})();